// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2026 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { cartHeaderStyles } from "@insite/content-library/Widgets/Cart/CartHeader";
import { getNotifyStyle } from "@steiner/App/Components/Notify/Notify";
import { mergeWithCss } from "@steiner/XDL/Utilities/mergeWithCss";
import { css } from "styled-components";

cartHeaderStyles.approvalEditWrapper = {
    css: css`
        width: 100%;
        text-align: center;
        padding: 10px;
        margin-bottom: 10px;
    `,
};

cartHeaderStyles.approvalEditText = {
    ...mergeWithCss(getNotifyStyle("info"), {
        css: css`
            margin: 0;
        `,
    }),
};
